import {
  getGTMImageDescription,
  getImageNameFromUrl,
  getVideoIdFromUrl,
} from '@/common/analytics/gtm/shared/analyticsEventsComposers';
import { DefaultTrackPromotionEvent } from '@/common/analytics/gtm/shared/trackViewPromotion';
import { HomepageConfig } from '@/modules/HomePage/HomePageConfig';
import { HomepageEventFiles, HomepageFeaturedEventV2 } from 'generatedBfw/static';

// Creative name is using only one type of image if the image is just different size
// or differently cropped but still the same image. Featured events use the same image just
// cropped differently for different devices or different sizes.

export type FeaturedEventPromotionEvent = Omit<DefaultTrackPromotionEvent, 'creative_size'> & {
  creative_size?: string;
};

export const createFeaturedEvent = (
  event: HomepageFeaturedEventV2,
): FeaturedEventPromotionEvent => {
  const imgDesc = getGTMImageDescription();
  return {
    promotion_id: `featured_event|${HomepageConfig.analyticsGaName}|${event.id}`,
    promotion_name: event.title,
    promotion_type: 'featured_event',
    creative_name: event.video?.source
      ? getVideoIdFromUrl(event.video.source)
      : getImageNameFromUrl((event.files as HomepageEventFiles).desktopStandard), // if there is no video files must be specified
    creative_slot: 'featured_event|1',
    creative_size: event.video?.source ? undefined : imgDesc,
  };
};
